import { render } from "./Photo.vue?vue&type=template&id=4ff920e5&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import "./Photo.vue?vue&type=style&index=0&id=4ff920e5&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff920e5"]])

export default __exports__